import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import type { InputState } from '../../input-state.js';
import { Text } from '../Text.js';

interface Props {
  inputState: InputState<boolean>;
}

export const Placeholder: FC<Props> = ({ inputState }) => {
  return match(inputState, {
    NotSubmitted: ({ value }) => (
      <Text skin="secondary">({value ? 'Y/n' : 'y/N'})</Text>
    ),
    Submitted: ({ value }) => <Text>{value ? 'Yes' : 'No'}</Text>,
  });
};
